// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ObjectCard-base__Gnngm{min-width:var(--size-72);max-width:calc(var(--size-60)*2 + var(--size-5));overflow:clip}.ObjectCard-inner__rWJSC{display:flex;flex-direction:column;gap:var(--size-3);padding:var(--size-4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ObjectCard-base__Gnngm",
	"inner": "ObjectCard-inner__rWJSC"
};
export default ___CSS_LOADER_EXPORT___;
